import { useTranslation } from 'react-i18next';

import { StatCard } from '@/shared/ui';
import type { StatsData } from '../../model/types';
import { LostDamagedStatsCard } from './lost-damaged-stats-card';

interface StockOnHandStatsProps {
  stats: StatsData | null;
  isLoading: boolean;
}

export function StockOnHandStats({ stats, isLoading }: StockOnHandStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
      <StatCard label={t('welcome.chart.totvol.rec.label')} value={stats?.totalVolume} isLoading={isLoading} />
      <StatCard label={t('welcome.chart.longstock.label')} value={stats?.longStandingPerc} isLoading={isLoading} />
      <LostDamagedStatsCard damaged={stats?.damageTotal} isLoading={isLoading} />
      <StatCard label={t('welcome.chart.shortstock.label')} value={stats?.expiringSOH} isLoading={isLoading} />
    </div>
  );
}
